var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',{staticClass:"pa-0",attrs:{"id":"layout"}},[_c('router-view',{key:_vm.$route.fullPath})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }